export function downloadCsv(columns, rows, fileName) {
  const header = columns.map(c => c.title || c.field || "").join(",");
  const csvRows = rows.map(row =>
    columns
      .map(col => {
        const value =
          typeof col.field === "string" ? row[col.field] : row[col.field?.()];

        const str = value == null ? "" : String(value);
        const escaped = '"' + str.replace(/"/g, '""') + '"';
        return escaped;
      })
      .join(",")
  );

  const csvString = [header, ...csvRows].join("\n");
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
